"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _player = require("@/api/player/player");
var _message = require("@/api/message/message");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ZhjyTable: _zhjyTable.default,
    ZhjyPagination: _zhjyPagination.default
  },
  name: "player",
  data: function data() {
    return {
      playerInfo: {},
      list: [],
      minWidth: 200,
      listData: [],
      listData2: [],
      totalData: 0,
      defaultColumn: [{
        name: "项目组别",
        prop: "groupName",
        isShow: true,
        width: "100"
      }, {
        name: "所属项目",
        prop: "matchName",
        isShow: true,
        width: "100"
      }, {
        name: "开始日期",
        prop: "startTime",
        isShow: true,
        width: "150"
      }, {
        name: "截止日期",
        prop: "endTime",
        isShow: true,
        width: "150"
      }],
      defaultColumn2: [{
        name: "项目组别",
        prop: "groupName",
        isShow: true,
        width: "100"
      }, {
        name: "所属项目",
        prop: "matchName",
        isShow: true,
        width: "100"
      }, {
        name: "开始日期",
        prop: "startTime",
        isShow: true,
        width: "150"
      }, {
        name: "截止日期",
        prop: "endTime",
        isShow: true,
        width: "150"
      }],
      page: {
        pageSize: 10,
        pageNum: 1
      },
      page2: {
        pageSize: 10,
        pageNum: 1
      },
      options: [{
        name: "进入",
        class: "edit",
        option: "enter",
        span: 3
      }],
      options2: [{
        name: "查看",
        class: "edit",
        option: "view",
        span: 3
      }]
    };
  },
  created: function created() {
    this.getMatchPlayerInfo();
    this.getPlayerMatchList();
    this.getMessageList();
  },
  methods: {
    getMatchPlayerInfo: function getMatchPlayerInfo() {
      var _this = this;
      (0, _player.getMatchPlayerInfo)().then(function (res) {
        _this.playerInfo = res.data;
      });
    },
    // 进入
    enter: function enter(e) {
      this.$router.push({
        path: "/player/playerList",
        query: {
          groupId: e.groupId,
          matchId: e.matchId
        }
      });
    },
    getPlayerMatchList: function getPlayerMatchList() {
      var _this2 = this;
      (0, _player.getPlayerMatchList)(_objectSpread(_objectSpread({}, this.page), {}, {
        year: "2021"
      })).then(function (res) {
        _this2.listData = res.data.list;
        _this2.totalData = res.data.total;
      });
    },
    getMessageList: function getMessageList() {
      var _this3 = this;
      (0, _message.getMessageList)({
        pageNum: 1,
        pageSize: 3
      }).then(function (res) {
        _this3.list = res.data.list;
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNum = e;
      this.getPlayerMatchList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNum = 1;
      this.getPlayerMatchList();
    }
  }
};